import React, { forwardRef } from 'react';
import clsx from 'clsx';
import CheckIcon from '@material-ui/icons/Check';
import MuiMenuItem from '@material-ui/core/MenuItem';
import useStyles from './styles';
import { MenuOptionProps, OverridableMenuOption } from './types';

const MenuOption = forwardRef(function MenuOption<C extends React.ElementType>(
    props: MenuOptionProps<C, { component?: C }>,
    ref: React.ComponentPropsWithRef<C>,
): JSX.Element {
    const { className, icon, children, ...rest } = props;
    const classes = useStyles();

    return (
        <MuiMenuItem ref={ref} className={clsx({ [classes.checkedIcon]: icon, className })} {...rest}>
            {children}
            {icon}
        </MuiMenuItem>
    );
});

MenuOption.defaultProps = {
    icon: <CheckIcon fontSize="small" />,
};

export type { MenuOptionProps };
export default MenuOption as OverridableMenuOption;
